export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10132.388182af.jpg";